import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import PortalBackground from '../PortalBackground';
import {
  startPagePadding,
  startPageMaxWidth,
  startPageTitle,
  startPageSubtitle,
  startBackButton
} from './startPageTokens';

/**
 * Shell for /start subpages (Meet the Team, Success Stories, CQC Home).
 * Does not render StartSidebar — App.js provides it for /start routes.
 */
const StartSubpageLayout = ({
  title,
  subtitle,
  onBack,
  embedded = false,
  children
}) => {
  const navigate = useNavigate();
  const handleBack = onBack || (() => navigate(-1));

  if (embedded) {
    return <div className="start-page-embedded text-left">{children}</div>;
  }

  return (
    <div className={`min-h-screen relative ${startPagePadding}`}>
      {/* Same ambient BBA background the Start Dashboard shows */}
      <PortalBackground />
      <div className={`relative ${startPageMaxWidth}`}>
        <header className="mb-6">
          <div className="flex items-center gap-3">
            <div className="flex-1 flex justify-start min-w-0">
              <button type="button" onClick={handleBack} className={startBackButton}>
                <FaArrowLeft className="w-4 h-4 shrink-0" aria-hidden />
                <span>Back</span>
              </button>
            </div>
            {/* Shrinkable so a long title wraps instead of crowding the Back button. */}
            <div className="min-w-0 text-center px-2 max-w-[60%] sm:max-w-[72%]">
              <h1 className={`${startPageTitle} text-center`}>{title}</h1>
              {subtitle ? <p className={`${startPageSubtitle} text-center`}>{subtitle}</p> : null}
            </div>
            <div className="flex-1 min-w-0" aria-hidden="true" />
          </div>
        </header>
        {children}
      </div>
    </div>
  );
};

export default StartSubpageLayout;
